import styled from "@emotion/styled";
import { Accordion, accordionSummaryClasses, Box, Button, Divider } from "@mui/material";
import LineItemGrid from "components/Common/LineItemGrid/LineItemGrid";

export const CustomQuoteHistoryWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	background: "white",
	border: theme.project.borders.presets.thinOutline,
	marginBottom: "20px",
	gap: "16px",
	width: "100%",
	boxSizing: "border-box"
}));

export const CustomQuoteHistoryContent = styled.div({
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: "16px",
	width: "100%"
});

export const CustomQuoteHistoryAccordion = styled(Accordion)(({ theme }) => ({
	[`& .${accordionSummaryClasses.root}`]: {
		...theme.project.typography.subtitle.subtitle2,
		color: theme.project.colors.primaryColors.main,
		background: theme.project.colors.backgroundColors.accordionSummary,
		borderBottom: theme.project.borders.presets.thinOutline,
		margin: "0px"
	},
	boxShadow: "none",
	position: "initial",
	marginTop: "0px !important",
	"& .MuiAccordionDetails-root": {
		padding: 0,
		"& > div": {
			margin: 0,
			paddingTop: 0
		}
	}
}));

export const CustomQuoteHistoryItemBox = styled(Box)(({ theme }) => ({
	borderRadius: "4px",
	color: theme.project.colors.backgroundColors.main,
	paddingRight: "29px",
	display: "flex",
	flexDirection: "column",
	marginBottom: "20px",
	gap: 16,
	justifyContent: "space-between",
	width: "100%",
	boxSizing: "border-box",
	button: {
		height: 36
	}
}));

export const CustomQuoteItemDetailField = styled.div({
	display: "flex",
	flexDirection: "column",
	width: "100%"
});

export const CustomQuoteLineItemGrid = styled(LineItemGrid)<{ isListPrice?: boolean }>(({ theme, isListPrice }) => ({
	display: "grid",
	"& > div:first-of-type > div:first-of-type": {
		gridColumn: "span 6"
	}
}));

export const CustomQuoteHistoryItemHeader = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	flexWrap: "wrap",
	gap: "4px",
	width: "100%",

	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "6px"
	},
	"& > div:last-of-type": {
		order: 1
	},
	"& > div:first-of-type": {
		order: 2
	},

	[theme.breakpoints.up("sm")]: {
		"& > div:last-of-type": {
			order: 2
		},
		"& > div:first-of-type": {
			order: 1
		}
	}
}));

export const CustomQuoteHistoryItemContent = styled(Box)({
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	width: "100%"
});

export const CustomQuoteHistoryPriceText = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main
}));

export const HistoryHeaderLeft = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	gap: "8px",
	...theme.project.typography.body.body2
}));

export const HistoryHeaderText = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	flexWrap: "wrap",
	gap: "8px",
	color: theme.project.colors.fontColors.main,
	...theme.project.typography.body.body2,
	fontSize: "1rem"
}));

export const HistoryHeaderRight = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main,
	paddingRight: "20px"
}));

export const CountStyle = styled.div({
	fontWeight: "bold"
});

export const ResponsiveDivider = styled(Divider)(({ theme }) => ({
	my: 2,
	width: "100%",
	maxWidth: "97%",
	[theme.breakpoints.down("sm")]: {
		maxWidth: "93%"
	}
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	color: theme.project.colors.semanticColors.error,
	"span:first-of-type": {
		marginTop: "4px"
	}
}));
